import React, { useState } from "react";
import { PopupModal } from "react-calendly";
import { NavLink, useNavigate } from "react-router-dom";

const AboutLocal = () => {

  const navigate = useNavigate();
  const [calpop, setCalpop] = useState(false);

  return (
    <>
    <PopupModal
        url="https://calendly.com/team-metbrains/30min"
        onModalClose={() => setCalpop(false)}
        open={calpop}
        rootElement={document.getElementById("root")}
      />
    <div className="about_local_expert container">
      <div className="about_local_expert_left">
        <p
          style={{
            color: "#000",
            fontSize: "18px",
            marginBottom: "5px",
            position: "relative",
            width: "fit-content",
          }}
        >
          Our Story
          <span
            style={{
              position: "absolute",
              bottom: "0px",
              left: "0px",
              right: "0px",
              height: "2px",
              background:
                "linear-gradient(to right, #006bff, #006bff 50%, #ff8000 50%)",
            }}
          ></span>
        </p>

        <h5 style={{ fontSize: "32px" }}>
          How MetBrains Started
        </h5>
        <p style={{ marginTop: "24px" }}>
          Metbrains was founded with one belief: <strong>education should translate into employability</strong>. Too many learners spend time and money on courses that don’t connect with the real world. We built Metbrains to change that—creating a mentorship-driven platform where <strong>skills meet opportunities</strong>.
        </p>
        <p>
          What started as a small initiative to mentor a handful of students has grown into a full-fledged learning ecosystem, trusted by learners across industries and geographies.
        </p>

      </div>
      <div className="about_local_expert_right">
        <h4>Connect with an expert today</h4>
        <p>Get in touch with a specialist recruiter to discuss your needs.</p>
        <button onClick={() => {setCalpop(true)}} style={{ fontFamily: "DM Sans", background: "#ff8000", fontWeight: "500" }}>
          <img src="/calendly-logo.svg" width={20} style={{ width: "20px", marginRight: "7px" }} /> Book a 1:1 Call
        </button>
        <NavLink to={"/download-brochures"} style={{marginTop:"24px"}} href="">Download our program brochures</NavLink>
      </div>
    </div>
    </>
  );
};

export default AboutLocal;
